import { createAsyncThunk } from '@reduxjs/toolkit'
import { LOCAL_STORAGE } from 'app/commons/constants'
import { getLanguage } from 'app/commons/helpers'
import settingApi from 'app/services/settingApi'

const handleGetInfo = createAsyncThunk('info/handleGetInfo', async () => {
  try {
    const currentLanguage = getLanguage(localStorage.getItem(LOCAL_STORAGE.I18NEXTLNG))
    const res = await settingApi.getInfoSetting(currentLanguage)
    const arrData = res.map((r: any) => r.data)
    return {
      units: arrData[0],
      commodities: arrData[1],
      ports: arrData[2],
    }
  } catch (error) {
    console.debug(error)
  }
})

export default handleGetInfo
